document.addEventListener("DOMContentLoaded", () => {
    const $cards = document.querySelectorAll(".perspective");

    if ($cards.length > 0) {
        VanillaTilt.init($cards, {
            max: 5, // Maximum tilt angle
            speed: 700, // Speed of the enter/exit transition
            scale: 1.0, // Scale on hover
            perspective: 1000,
            reset: true,
        });
    } else {
        console.error("No elements with class 'perspective' found");
    }
});
